import { UAParser } from 'ua-parser-js'
import { detectWeChatMiniProgram } from './useWeChatSDK.js'

const getDeviceInfo = async () => {
  const device = {}
  const uap = new UAParser()
  const result = await uap.getResult().withClientHints()
  const isWechatMiniProgram = await detectWeChatMiniProgram()

  device.model = result.device.model ?? 'unknown'
  device.vendor = result.device.vendor ?? 'unknown'
  device.deviceType = result.device.type
  device.os = result.os.name
  device.osVersion = result.os.version
  device.isMiniProgram = isWechatMiniProgram
  device.browser = isWechatMiniProgram
    ? 'wechat-miniprogram'
    : result.browser.name
  device.browserVersion = result.browser.version
  device.browserMajorVersion = result.browser.major
  device.browserEngine = result.engine.name
  device.browserEngineVersion = result.engine.version

  device.isMobileOrTablet = () => {
    const type = device.deviceType?.toLowerCase()
    return type === 'mobile' || type === 'tablet'
  }

  device.isWechat = () => {
    return device.browser?.toLowerCase() === 'wechat' || device.isMiniProgram
  }

  return device
}

export { getDeviceInfo }
